// extracted by mini-css-extract-plugin
export var actionText = "_q3-4";
export var container = "_q3-0";
export var leftSection = "_q3-1";
export var rightSection = "_q3-2";
export var settingsButton = "_q3-6";
export var settingsIcon = "_q3-7";
export var shortcut = "_q3-5";
export var shortcutGroup = "_q3-3";